/**
 * メッセージ
 */
export const Messages = {
  select: {
    failure: '取得に失敗しました。',
  },
  create: {
    success: '作成しました。',
    failure: '作成に失敗しました。',
  },
  update: {
    success: '更新しました。',
    failure: '更新に失敗しました。',
  },
  delete: {
    success: '削除しました。',
    failure: '削除に失敗しました。',
  },
} as const;

export type Messages = typeof Messages[keyof typeof Messages];
